import React, { useState, useRef, useEffect } from 'react';
import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import { REPORT_TYPE_SET } from '../../../../config/ReportOptionSet';

import DropdownCustomLabel from '../../../container/dropdown/dropdown-custom-create/DropdownCustomLabel';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';
import './CustomCreateInformation.css';

const QueryTypeIcon = (props) => {
  switch (props.query_type) {
    case "BASIC":{
      return(
        <span className="type_basic">
          {props.query_type}
        </span>
      )
    }
    case "BOOLEAN":{
      return(
        <span className="type_bool">
        {props.query_type}
      </span>
      )
    }
    default:
      return null;
  }
}

const ReportTypeIcon = (props) => {
  switch (props.report_type) {
    case "volume":{
      return(
        <span className="type_volu">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "sentiment":{
      return(
        <span className="type_sent">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "source":{
      return(
        <span className="type_sour">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "relation":{
      return(
        <span className="type_wordcloud">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "category":{
      return(
        <span className="type_cate">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "positioningmap":{
      return(
        <span className="type_positioning">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "buzzlist":{
      return(
        <span className="type_buzzlist">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    default:
      return null;
  }
}

const CustomCreateInformation = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])


  return (
    <div id="reportInformation">
      <div id="reportTitBtn">
        <div id="reportTit">선택한 리포트</div>
        {/* <div id="custom-manageBtn"> */}
        <div id="manageBtn">
          <a className="button purple_line"  onClick={()=>props.handleResetBtn()}>초기화</a>
          &nbsp;
          {props.edit ?
            <DropdownCustomLabel customLabel={props.customLabel} toggle="수정" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>
            : <DropdownCustomLabel customLabel={props.customLabel} toggle="저장" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>}
          <TooltipWithTimer target={tooltipTarget} show={tooltipShow} tooltipDirection="top" tooltipText="커스텀 리포트가 저장되었습니다" />
        </div>
      </div>
      {props.selectedReportQueryArray.map(reportQuery=>{
        return (
          <>
            {props.selectedReportArray.filter(report=>report.reportID==reportQuery.reportID).map(report=>{
              return(
                <div className="buzzReport">
                <table className="buzzTablesty">
                  <tr>
                    <td colSpan="2">
                      <span className="buzzTxt">
                        {report.name}
                      </span>
                      &nbsp;
                        <ReportTypeIcon report_type={report.REPORT_TYPE} />
                      &nbsp;
                      <span className="btn" onClick={()=>props.handleRemoveBtn(report.reportID)}><a>X</a></span>
                    </td>
                  </tr>
                  <tr>
                    <td width="14%" className="tit">Date</td>
                    <td width="86%">
                      {`${JSON.parse(report.content).date[0].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')} ~ ${JSON.parse(report.content).date[1].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`}
                    </td>
                  </tr>
                  <tr>
                    <td className="tit">Channel</td>
                    <td>
                      {JSON.parse(report.content).channels.map((item,index,array)=>{
                        if (index == array.length-1){
                          return(
                            <>{Channel_CODE_SET[item]}</>
                          )
                        }
                        else{
                          return(
                            <>{Channel_CODE_SET[item]},&nbsp;</>
                          )
                        }
                      })}
                    </td>
                  </tr>
                  <tr>
                    <td className="tit">Base Keyword</td>
                      {props.queryData.info.filter(item=>item.queryID==reportQuery.mainQuery).map(item=>{
                        return(
                          <td>
                            <strong>{item.name}</strong>&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} />
                          </td>
                        )
                      })}
                  </tr>
                  {reportQuery.subQuery.length == 0 ? undefined:
                    <tr>
                      <td className="tit">Sub Keyword</td>
                      <td>
                        {reportQuery.subQuery.map(subQueryItem=>{
                          return(
                            <>
                              {props.queryData.info.filter(item=>item.queryID==subQueryItem.queryID).map((item, index, array)=>{
                                if (index == reportQuery.subQuery.length-1){
                                  return(
                                    <>
                                      {item.name}&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} />
                                    </>
                                  )
                                }
                                else{
                                  return(
                                    <>
                                      {item.name}&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} />,&nbsp;&nbsp;
                                    </>
                                  )
                                }
                              })}
                            </>
                          )})}
                      </td>
                    </tr>}
                </table>
              </div>
              )
            })}
          </>
        )}
      )}
    </div>
  )
}

export default CustomCreateInformation;